import {ReactComponent as World} from "assets/image/Layout/ObjectPanel/Layer/ic_world.svg";

export const objectIcons = {
  World: <World />,
};
